import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const tcgdexSetsColumns = [
  { field: "series_name", headerName: "Series", flex: 1, minWidth: 160 },
  { field: "set_name", headerName: "Set", flex: 1, minWidth: 200 },
  { field: "set_id", headerName: "Set ID", width: 120 },
  { field: "card_count", headerName: "Card Count", width: 120 },
];

function CardsTcgdexSetsDialog({
  open,
  onClose,
  rows,
  loading,
  error,
  onDownloadSets,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>TCGdex Sets</DialogTitle>
      <DialogContent>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
          <Button
            variant="outlined"
            onClick={onDownloadSets}
            disabled={loading}
          >
            {loading ? "Downloading..." : "Download Sets"}
          </Button>
          <div style={{ fontSize: 12, color: "#666" }}>
            Downloads latest series + sets from TCGdex (use this when new sets release).
          </div>
        </div>

        {error ? (
          <div style={{ color: "#d32f2f", marginBottom: 8 }}>
            {error.error || error.message || "Failed to load sets"}
          </div>
        ) : null}

        <div style={{ height: 420, width: "100%" }}>
          <DataGrid
            rows={(rows || []).map((r) => ({ ...r, id: r.set_id || r.id }))}
            columns={tcgdexSetsColumns}
            loading={loading}
            disableRowSelectionOnClick
            pageSizeOptions={[25, 50, 100]}
            initialState={{
              pagination: { paginationModel: { pageSize: 50, page: 0 } },
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CardsTcgdexSetsDialog;
